const MAIN_SENTINEL = 'main'

/** Sanitize a work-area name to the charset allowed in a WS path segment. */
function sanitizeSegment(s: string): string {
  return s.replace(/[^A-Za-z0-9._-]/g, '_')
}

/**
 * Bridge session id for the Claude panel, matching the cc-claude convention:
 *   main / empty / undefined → `workspace-${appName}`
 *   worktree `${session}`    → `workspace-${appName}-${sanitize(session)}`
 */
export function claudeBridgeSessionId(appName: string, session?: string): string {
  if (!session || session === MAIN_SENTINEL) return `workspace-${appName}`
  return `workspace-${appName}-${sanitizeSegment(session)}`
}
